import { Component, OnInit } from '@angular/core';
import { AdminAccountComponent } from '../account.component';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss']
})
export class AdminAccountListComponent extends AdminAccountComponent implements OnInit {
  public title = 'Account list';
  public ngOnInit() {
    super.ngOnInit();
    this.loadItems();
  }

  public loadItems() {
    super.loadItems();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/account/list/account-list.component.ts